import { useQueryClient } from '@tanstack/react-query';

import {
  getApiV1SerievideoSeriesSerieidQueryOptions,
  useDeleteApiV1SerievideoId,
} from '@/shared/api/generated';

/**
 * Hook para excluir um Vídeo.
 *
 * Envolve o mutation gerado pelo Kubb para `DELETE /api/v1/serievideo/{id}` e
 * invalida o cache da listagem de vídeos da série após a exclusão bem-sucedida.
 * Exclusão física — remove também as traduções (idiomas) do vídeo.
 *
 * @param serieId - ID da série a que o vídeo pertence (para invalidar a listagem correta)
 *
 * @example
 * ```tsx
 * const deleteSerieVideo = useDeleteSerieVideo(serieId);
 * deleteSerieVideo.mutate({ id: 42, params: { serieId } });
 * ```
 */
export function useDeleteSerieVideo(serieId: number) {
  const queryClient = useQueryClient();

  return useDeleteApiV1SerievideoId({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getApiV1SerievideoSeriesSerieidQueryOptions(serieId));
      },
    },
  });
}
